import React from 'react';
import ApartmentCatalog from '../components/ApartmentCatalog';

const ApartmentCatalogPage = () => {
  return (
    <div>
      <ApartmentCatalog />
    </div>
  );
};

export default ApartmentCatalogPage;